// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as DescargaEbooksRouteImport } from './routes/descarga-ebooks'
import { Route as GuiaPrincipiantesRouteImport } from './routes/guia-principiantes'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const DescargaEbooksRoute = DescargaEbooksRouteImport.update({
            id: '/descarga-ebooks',path: '/descarga-ebooks',getParentRoute: () => rootRouteImport
          })
const GuiaPrincipiantesRoute = GuiaPrincipiantesRouteImport.update({
            id: '/guia-principiantes',path: '/guia-principiantes',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogRoute: BlogRouteWithChildren,DescargaEbooksRoute: DescargaEbooksRoute,GuiaPrincipiantesRoute: GuiaPrincipiantesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)